import { useCallback, useEffect, useRef, useState } from 'react'

export const useSortableHeaderCell = ({ onSelect }) => {
	const [isOpen, setIsOpen] = useState(false)
	const triggerRef = useRef(null)
	const menuRef = useRef(null)

	const close = useCallback(() => setIsOpen(false), [])
	const toggle = useCallback(() => setIsOpen(v => !v), [])

	const handleSelect = useCallback(
		opt => {
			onSelect?.(opt)
		},
		[onSelect]
	)

	useEffect(() => {
		if (!isOpen) return

		const onDocClick = e => {
			const t = e.target
			if (!t) return

			const inTrigger = triggerRef.current?.contains(t)
			const inMenu = menuRef.current?.contains(t)
			if (inTrigger || inMenu) return

			close()
		}

		const onKey = e => {
			if (e.key === 'Escape') close()
		}

		document.addEventListener('mousedown', onDocClick)
		document.addEventListener('keydown', onKey)

		return () => {
			document.removeEventListener('mousedown', onDocClick)
			document.removeEventListener('keydown', onKey)
		}
	}, [isOpen, close])

	return {
		isOpen,
		triggerRef,
		menuRef,
		close,
		toggle,
		handleSelect,
	}
}
